const timeUnits = {
  year: 24 * 60 * 60 * 1000 * 365,
  month: (24 * 60 * 60 * 1000 * 365) / 12,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000,
};
type TimeUnit = keyof typeof timeUnits;

function findFittingUnitForDuration(duration: number): TimeUnit {
  let fittingFormat: TimeUnit = "second";
  for (const unitString in timeUnits) {
    const unit = unitString as TimeUnit;
    if (Math.abs(duration) > timeUnits[unit]) {
      fittingFormat = unit;
      break;
    }
  }
  return fittingFormat;
}

export default function relativeDateString(date: Date): string {
  const timeFormatter = new Intl.RelativeTimeFormat("de", { numeric: "auto" });
  const elapsedMs = date.getTime() - Date.now();
  const fittingFormat: TimeUnit = findFittingUnitForDuration(elapsedMs);

  const time = Math.round(elapsedMs / timeUnits[fittingFormat]);
  return timeFormatter.format(time, fittingFormat);
}
